let pagination;
let templateRequest;
let deferredTemplateRequest;

function paginationBusy( busy ) {
	if( !pagination ) { return; }
	if( busy ) {
		pagination.style.display = 'none';
	}	
}

function setupTemplateRequest( getData ) {
	templateRequest = getData;

	if( deferredTemplateRequest ) {
		templateRequest( deferredTemplateRequest );
		deferredTemplateRequest = null;
	}
}

function getSingleParam( param, url = window.location.search ) {
	const obj = {};
	url.replace( /[?&]+([^=&]+)=([^&]*)/gi, ( match, p1, p2 ) => { obj[p1] = p2; } )
	return param ? ( obj[param] || null ) : obj;
}

function clickedItem( e ) {
	const { endpoint } = e.target.dataset;
	if( endpoint && endpoint.length && endpoint !== '#' ) {
		templateRequest( endpoint );
		window.scrollTo({ top: 0, behavior: 'smooth' });
		e.preventDefault();
	}
}

function errorState() {
	if( !pagination ) { return; }
	pagination.style.display = 'none';
}

function renderPagination( results ) {
	if( !pagination || !results?.meta || !results?.data || !results?.data?.length || !results?.links ) {
		errorState();
		return;
	}

	const paginationList = pagination.querySelector( '.pagination' );
	const nextPageString = pagination.dataset.next;
	const prevPageString = pagination.dataset.prev;
	const totalResults = results.meta.count;
	const currentResultsTotal = results.data.length;
	const nextPage = ( results.links.next != null ) ? results.links.next.href : null;
	const prevPage = ( results.links.prev != null ) ? results.links.prev.href : null;
	let currentPageURL = results.links.self.href;

	let resultsPerPage = parseInt( getSingleParam( 'page[limit]', currentPageURL ), 10 );
	if(resultsPerPage === null || Number.isNaN( resultsPerPage ) ) { resultsPerPage = parseInt( getSingleParam( encodeURIComponent( 'page[limit]' ), currentPageURL ), 10 ); }
	if(resultsPerPage === null || Number.isNaN( resultsPerPage ) ) { resultsPerPage = 14; }

	let currentPageOffset = parseInt( getSingleParam( 'page[offset]', currentPageURL ), 10 );
	if(currentPageOffset === null || Number.isNaN( currentPageOffset ) ) { currentPageOffset = parseInt( getSingleParam( encodeURIComponent( 'page[offset]' ), currentPageURL ), 10 ); }
	if(currentPageOffset === null || Number.isNaN( currentPageOffset ) ) { currentPageOffset = 0; }

	// remove the contents of the pagination list so we can populate it all over again
	paginationList.replaceChildren();

	// added no offset to the url if the param isn't present in the url at all
	if( currentPageURL.indexOf( 'page[offset]' ) === -1 ) {
		currentPageURL = currentPageURL.concat( '&page[offset]=0' );
	}

	// check if pagination is necessary, if not hide it
	if( totalResults > currentResultsTotal ) {

		// if prev link exists output prev link, if not output disabled button
		const prevItem = document.createElement( 'li' );
		prevItem.classList.add( 'page-item', 'prev' );
		if( prevPage != null ) {
			prevItem.innerHTML = `<button data-endpoint="${prevPage}" class="page-link">${prevPageString}</button>`;
		} else {
			prevItem.classList.add( 'disabled' );
			prevItem.innerHTML = `<button data-endpoint="#" class="page-link">${prevPageString}</button>`;
		}
		paginationList.appendChild( prevItem );

		// for loop that iterates by resultsPerPage and outputs a link for each result
		for( let i = 0; i * resultsPerPage < totalResults; i += 1 ) {
			const pageLinkOffset = i * resultsPerPage;
			const pageLink = currentPageURL.replace(/page\[offset\]=[0-9]+/, `page[offset]=${pageLinkOffset}` );

			const item = document.createElement( 'li' );
			item.classList.add( 'page-item' );

			const btn = document.createElement( 'button' );
			btn.setAttribute( 'data-endpoint', pageLink );
			btn.classList.add( 'page-link' );
			btn.innerText = i + 1;

			if( pageLinkOffset === currentPageOffset ) {
				item.classList.add( 'active' );
				btn.setAttribute( 'aria-current', 'page' );
			} else if( pageLinkOffset === currentPageOffset - resultsPerPage ) {
				item.classList.add( 'active-sibling' );
			}

			item.appendChild( btn );
			paginationList.appendChild( item );
		}

		// if next link exists output next link, if not output disabled button
		const nextItem = document.createElement( 'li' );
		nextItem.classList.add( 'page-item', 'next' );
		if( nextPage != null ) {
			nextItem.innerHTML = `<button data-endpoint="${nextPage}" class="page-link">${nextPageString}</button>`;
		} else {
			nextItem.classList.add( 'disabled' );
			nextItem.innerHTML = `<button data-endpoint="#" class="page-link">${nextPageString}</button>`;
		}
		paginationList.appendChild( nextItem );

		Array.from( paginationList.querySelectorAll( 'button' ) ).forEach( ( ele ) => {
			ele.addEventListener( 'click', clickedItem );
		} );

		pagination.style.display = 'block';
	} else {
		pagination.style.display = 'none';
	}
}

function init() {
	pagination = document.querySelector( '.pagination__block' );
}

if (
	document.readyState === "complete" ||
	(document.readyState !== "loading" && !document.documentElement.doScroll)
) {
	init();
} else {
	let eventSrcUrl = null;
	document.addEventListener('DOMContentLoaded', ( e ) => {
		if( eventSrcUrl !== e.target.URL ) {
			eventSrcUrl = e.target.URL
			init();
		}
	} );
}

export default {
	setupTemplateRequest, // call this to setup the 2-way communication
	renderPagination, // call this when the page recieves new data
	paginationBusy, // call this when the page initiates a new request
};